import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_LOGS = createAsyncActionType("GET_LOGS");

export const GET_LOGS_COUNT = createAsyncActionType("GET_LOGS_COUNT");

export const SET_LOG_SEARCH_FILTERS = "SET_LOG_SEARCH_FILTERS";

export const SET_LOGS_CURRENT_PAGE = "SET_LOGS_CURRENT_PAGE";

export const CLEAR_LOGS = "CLEAR_LOGS";

export const SET_LOGS_ITEMS_PER_PAGE = "SET_LOGS_ITEMS_PER_PAGE";

export const SET_LOGS_NO_ENTRIES_MESSAGE = "SET_LOGS_NO_ENTRIES_MESSAGE";

export const EXPORT_LOGS_CSV = createAsyncActionType("EXPORT_LOGS_CSV");

export const CLEAR_EXPORT_LOGS_CSV = "CLEAR_EXPORT_LOGS_CSV";



// WEBPACK FOOTER //
// ./src/features/log/types/logTypes.js